import React from "react";
import {SelectField} from "react-fields";

const CHART_PERIODS = [
    {name: 'Last 30 days', value: '30_days'},
    {name: 'Last 3 months', value: '3_months'},
    {name: 'Last 6 months', value: '6_months'},
    {name: 'Last 12 months', value: '12_months'},
    {name: 'All time', value: 'all'}
];

export default function PeriodSelector(props) {

    let periods = [...CHART_PERIODS];
    if (props.hideAllTimeFilter) {
        periods = periods.filter(t => t.value !== 'all');
    }

    return(
        <SelectField name={props.name} className={'label-icon-right select-label select-label--min-width dark ' + props.className}
                     onChange={props.onChange}
                     options={periods} optionsValue='value' optionsLabel='name'
                     selected={props.value} />
    )

}
